import { Routes } from '@angular/router';
import { RoutingNames } from 'shared';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from 'authentication';

export const routes: Routes = [
  {
    path: RoutingNames.authentication,
    loadChildren: () =>
      import('authentication').then((m) =>
        m.authenticationRoutes.filter((route) => route?.path === RoutingNames.loginOtp),
      ),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: LayoutComponent,
    children: [
      {
        path: 'projects',
        loadComponent: () => import('./manage-projects/manage-projects.page').then((c) => c.ManageProjectsPage),
      },
      {
        path: 'create-project',
        loadComponent: () => import('./project/project.page').then((c) => c.ProjectPage),
      },
      {
        path: 'project/:id',
        children: [
          {
            path: '',
            loadComponent: () => import('./project/project.page').then((c) => c.ProjectPage),
          },
        ],
      },
      {
        path: '**',
        redirectTo: 'projects',
      },
    ],
  },
];
